module.exports = __webpack_public_path__ + "static/media/history_8.bb99c930.jpg";